import React from 'react';

import { 
  Box, 
  Button, 
  InputAdornment, 
  TextField, 
  Typography 
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

// Buttons accept an optional `button<N>Disabled`; callers that don't pass it
// keep the previous always-enabled behaviour.
const TopBar = (props) => {
  return (
    <Box className="flexCenterSBRow"
      mb={"10px"}>
      <Typography variant='subtitle1'>
        {props.title}
      </Typography>

      <Box 
        className="flexCenter_Row" 
        gap={"15px"}>
        {
          (props.onSearchChange)
          &&
          <TextField
            // `searchPlaceholder` is optional — callers that don't pass one
            // keep the original generic placeholder.
            placeholder={props.searchPlaceholder || 'Search'}
            size='small'
            value={props.search}
            onChange={props.onSearchChange}
            InputProps={{
              startAdornment: 
                <InputAdornment position="start">
                  <SearchIcon 
                    sx={{ color: "#343434" }}/>
                </InputAdornment>,
            }}
            />
        }
        {
          (props.button4Text && props.button4OnClick)
          &&
          <Button 
            variant='contained'
            size='small'
            disabled={props.button4Disabled || false}
            onClick={props.button4OnClick}>
            {props.button4Text}
          </Button>
        }
        {
          (props.button3Text && props.button3OnClick)
          &&
          <Button 
            variant='contained'
            size='small'
            disabled={props.button3Disabled || false}
            onClick={props.button3OnClick}>
            {props.button3Text}
          </Button>
        }
        {
          (props.button2Text && props.button2OnClick)
          &&
          <Button 
            variant='contained'
            size='small'
            disabled={props.button2Disabled || false}
            onClick={props.button2OnClick}>
            {props.button2Text}
          </Button>
        }
        {
          (props.button1Text && props.button1OnClick)
          &&
          <Button
            variant='contained'
            size='small'
            disabled={props.button1Disabled || false}
            onClick={props.button1OnClick}>
            {props.button1Text}
          </Button>
        }
      </Box>
    </Box>
  )
}

export default TopBar;